!((document, Drupal, $) => {
  'use strict';
  /**
   * Toggle product cards open/closed
   */

  Drupal.behaviors.cardToggle = {

    attach: function (context) {

      // To ensure details are closed on phones on load,
      // but still functions on click.
      if ($(window).width() < 560) {
        $('.product-card__details-header').removeClass('js-open');
        $('.product-card__details--items').removeClass('js-open');
        $('.product-card__card-actions').removeClass('js-open');
      }

      $('.product-card__item', context).each(function() {
        const $card = $(this);
        const $cardHeader = $card.find('.product-card__details-header', context); // eslint-disable-line max-len
        const $cardBody = $card.find('.product-card__details--items', context); // eslint-disable-line max-len
        const $cardActions = $card.find('.product-card__card-actions', context); // eslint-disable-line max-len
        const $cardClose = $card.find('.close-button', context);


        $cardHeader.unbind('click').bind('click', function() {
          $cardHeader.toggleClass('js-open');
          $cardBody.toggleClass('js-open');
          $cardActions.toggleClass('js-open');
        });


        $card.find('.product-card__details--item').each(function() {
          const $section = $(this);
          const $sectionHeader = $section.find('.product-details__section-header', context); // eslint-disable-line max-len
          const $sectionContent = $section.find('.product-details__section-content', context); // eslint-disable-line max-len

          $sectionHeader.unbind('click').bind('click', function() {
            $sectionHeader.toggleClass('js-open');
            $sectionContent.toggleClass('js-open');
          });
        });

        $cardClose.on('click', function() {
          $card.remove();
        });
      });
    }
  };
})(document, Drupal, jQuery);
